import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiPaper from './MuiPaper';
import MUIRichTextEditor from './MUIRichTextEditor';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';

export default {
   MuiTextField: {
      defaultProps: {
         size: 'small',
         margin: 'dense'
      }
   },
   MuiOutlinedInput: {
      root: {
         borderRadius: '10px' 
      }
   },
   MuiButton,
   MuiIconButton,
   MuiPaper,
   MuiTableCell,
   MuiTableHead,
   MuiTypography,
   MUIRichTextEditor
};
